import type { ReactElement } from 'react'
import SectionHeader from '../components/SectionHeader'
import OrgNumber from '../components/OrgNumber'
import { useT } from '../i18n/useI18n'
import { addressLines, company } from '../data/company'
import type { CompanyAddress } from '../data/company'
import './contact.css'

function AddressBlock({ label, address }: { label: string; address: CompanyAddress }): ReactElement {
  return (
    <div className="contact-address-block">
      <div className="contact-address-label">{label}</div>
      <address className="contact-address">
        {addressLines(address).map((line) => <span key={line}>{line}<br /></span>)}
      </address>
    </div>
  )
}

export default function Contact(): ReactElement {
  const t = useT()

  return (
    <section className="section">
      <div className="container">
        <SectionHeader title={t('contact.heading')} subtitle={t('contact.subheading')} />

        <div className="row g-4 justify-content-center">
          <div className="col-lg-5">
            <div className="feature-box">
              <div className="feature-icon">
                <i className="bi bi-envelope"></i>
              </div>
              <h3>{t('contact.email')}</h3>
              <p className="description">
                <a href={`mailto:${company.email}`}>{company.email}</a>
              </p>
              <div className="feature-cta">
                <a href={`mailto:${company.email}`} className="btn btn-primary">
                  <i className="bi bi-send me-2"></i>
                  {t('contact.mailto')}
                </a>
              </div>
            </div>
          </div>

          <div className="col-lg-5">
            <div className="feature-box">
              <div className="feature-icon">
                <i className="bi bi-building"></i>
              </div>
              <h3>{t('contact.company')}</h3>
              <p className="description">
                {company.legalName}<br />
                <a href={company.registryUrl} target="_blank" rel="noopener noreferrer" title={t('contact.registry')}><OrgNumber /></a>
              </p>
              <AddressBlock label={t('contact.businessAddress')} address={company.businessAddress} />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
